module.exports = __webpack_public_path__ + "static/media/re.253d75a9.svg";